<template>
  <kst-page-details
    :actions="actions"
    @init="handleInit"
  >
    <b-tabs multiline v-model="activeTab" size="is-medium" type="is-boxed">
      <b-tab-item :label="tabs.Details">
        <Details :data="data"/>
        <ReceiveList :receiveList="data.ReceiveList"/>
      </b-tab-item>
    </b-tabs>
  </kst-page-details>
</template>

<script>
import Info from "../DbpyInfo.js";
import Model from "../DbpyModel.js";
import Services from "../../../services/Api/DebtPayServices.js";

import Details from "./DbpyD_Details.vue";
import ReceiveList from "./DbpyD_ReceiveList.vue";

export default {
  components: {
    Details,
    ReceiveList
  },
  data: () => ({
    actions: [],
    data: {},
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details
    }
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadDetails) {
      this.resetData(id);

      const config = Services.getDetailsData(id);
      loadDetails(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.data = data.Details;
      Model.setDetailsByStatus(this.data);
    },

    /*** custom ***/

    resetData(id) {
      const access = this.$kst.Access.create(Model.Access);
      this.data = {};

      // actions
      const urlParams = this.$kst.Route.getParams({
        [this.$kst.Enum.Param.ID]: id
      });

      this.actions = this.$kst.Access.getAvailableActions(
        Model.Details.Actions, Model.Module, urlParams, access
      );
    }
  }
}
</script>